/* global DetectUserAgent */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { client } from "filestack-react";

import { useFilestackActions } from "store/FilestackSlice";

import useSettings from "./useSettings";

const rootId = "FILESTACK_MODAL";

const containerId = "FILESTACK_CONTAINER";

export const GetHandleView = () => useSelector((state) => state.FilestackSlice.handleView);

const useFilestack = (onUpload, onError, closeModal) => {
  const {
    settings: { fileStack },
  } = useSettings();
  const isFbInAppBrowser = DetectUserAgent.isFBInAppBrowser();
  const { changeValue, resetValue } = useFilestackActions();

  const setHandleViewStorage = (value) => {
    if (isFbInAppBrowser) {
      sessionStorage.setItem("filestackModal", value);
    }
    changeValue(value);
  };

  const resetValueToStorage = () => {
    if (isFbInAppBrowser) {
      sessionStorage.removeItem("filestackModal");
    }
    resetValue();
  };

  const picker = client.Filestack(fileStack.appId, { cname: fileStack.cname, sessionCache: true }).picker({
    container: containerId,
    onUploadDone: (res) => {
      resetValueToStorage();
      onUpload(res);
    },
    rootId,
    displayMode: "overlay",
    fromSources: ["facebook"],
    accept: "image/*",
    disableTransformer: true,
    onCancel: () => resetValueToStorage(),
  });

  const open = () => {
    if (picker) {
      picker.open();
    }
  };
  const close = () => {
    if (picker) {
      picker.close();
    }
  };

  useEffect(() => {
    return () => {
      resetValueToStorage();
      close();
      if (closeModal) closeModal();
    };
  }, [window.location.pathname]);

  return {
    setHandleViewStorage,
    resetValueToStorage,
    rootId,
    containerId,
    open,
  };
};

export default useFilestack;
